import { getFullMonthLabel } from "@utils/fullMonthLabels";

/**
 * @param {import("dayjs").Dayjs | null} date
 * @returns {string | null}
 */
export function formatTxPickerDisplayDate(date) {
  if (!date) return null;
  const day = String(date.date()).padStart(2, "0");
  const month = String(date.month() + 1).padStart(2, "0");
  const year = date.year();
  return `${day}/${month}/${year}`;
}

/**
 * Builds a 6×7 grid starting Sunday-aligned for the month containing viewMonth.
 * @param {import("dayjs").Dayjs} viewMonth any day inside the target month
 * @returns {{ date: import("dayjs").Dayjs, inCurrentMonth: boolean }[]}
 */
export function buildMonthGrid(viewMonth) {
  const start = viewMonth.startOf("month");
  const startWeekday = start.day();
  const gridStart = start.subtract(startWeekday, "day");
  const cells = [];
  let d = gridStart;
  for (let i = 0; i < 42; i++) {
    cells.push({
      date: d,
      inCurrentMonth: d.month() === start.month(),
    });
    d = d.add(1, "day");
  }
  return cells;
}

/**
 * First click sets from, second sets to; if both already set, restart from clicked day.
 * @param {import("dayjs").Dayjs | null} pendingFrom
 * @param {import("dayjs").Dayjs | null} pendingTo
 * @param {import("dayjs").Dayjs} clicked
 * @returns {{ from: import("dayjs").Dayjs, to: import("dayjs").Dayjs | null }}
 */
export function computeRangeAfterClick(pendingFrom, pendingTo, clicked) {
  const day = clicked.startOf("day");
  if (!pendingFrom || (pendingFrom && pendingTo)) {
    return { from: day, to: null };
  }
  const start = pendingFrom.startOf("day");
  if (day.isBefore(start)) {
    return { from: day, to: pendingFrom };
  }
  return { from: pendingFrom, to: day };
}

/**
 * @returns {"endpoint" | "between" | null}
 */
export function getRangeCellKind(date, pendingFrom, pendingTo) {
  if (!pendingFrom) return null;
  const d = date.startOf("day");
  const from = pendingFrom.startOf("day");
  if (!pendingTo) {
    return d.isSame(from) ? "endpoint" : null;
  }
  const to = pendingTo.startOf("day");
  const start = from.isBefore(to) ? from : to;
  const end = from.isBefore(to) ? to : from;
  if (d.isSame(start) || d.isSame(end)) return "endpoint";
  if (d.isAfter(start, "day") && d.isBefore(end, "day")) return "between";
  return null;
}

export const CALENDAR_YEAR_MIN = 2026;
export const CALENDAR_YEAR_MAX = new Date().getFullYear();

export function buildYearOptions(
  fromYear = CALENDAR_YEAR_MIN,
  toYear = CALENDAR_YEAR_MAX,
) {
  const years = [];
  for (let y = fromYear; y <= toYear; y += 1) {
    years.push(y);
  }
  return years;
}

export const CALENDAR_MONTH_INDEXES = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11];

/**
 * @param {import("dayjs").Dayjs} viewMonth
 * @param {(key: string) => string} translate
 */
export function formatMonthYearTitle(viewMonth, translate) {
  return `${getFullMonthLabel(
    viewMonth.month(),
    translate,
  )} ${viewMonth.year()}`;
}
